import React from 'react';

import classNames from 'classnames';

import { IFIleEntity } from '@widgets/Files/model/types/fileEntity.interface';
import { IUploadFile } from '@widgets/Files/model/types/uploadFile.interface';
import { FileFolder } from '@widgets/Files/UI/FileFolder';

import cls from './FilesList.module.css';
import { useAppSelector } from '../../../store';
import { FileCard } from '../UI/FileCard/FileCard';
import { LoadingFileCard } from '../UI/FileCard/LoadingFileCard';

interface IFilesListProps {
    folders: IFIleEntity[];
    files: IFIleEntity[];
}

export const FilesList = ({ folders, files }: IFilesListProps) => {
    const uploadFiles = useAppSelector((state) => state.filesReducer.uploadFiles);
    return (
        <div className={classNames(cls.FilesList)}>
            {folders &&
                folders.length > 0 &&
                folders?.map((folder) => <FileFolder key={folder.id} folderInfo={folder} />)}
            {uploadFiles.map((file: IUploadFile, i: number) => (
                <LoadingFileCard key={file.name + i} file={file} />
            ))}
            {files?.map((file) => (
                <FileCard key={file.id} fileInfo={file} />
            ))}
        </div>
    );
};
